import { computed } from 'vue';
import { useMainMenuFilteredByRouter } from 'app/src/app/composables/use-main-menu-filtered-by-router';
import { applyUnreadBadgesToMenu } from 'app/src/shared/sidebar-unread-badges/apply-unread-badges';
import { useSidebarUnreadBadgesStore } from 'app/src/shared/sidebar-unread-badges/sidebar-unread-badges.store';

export function useMainMenuWithUnreadBadges() {
  const filteredMenu = useMainMenuFilteredByRouter();
  const unreadBadgesStore = useSidebarUnreadBadgesStore();

  return computed(() => {
    void unreadBadgesStore.stamp;
    return applyUnreadBadgesToMenu(filteredMenu.value, {
      badges: unreadBadgesStore.badges,
      dotMenuIds: new Set(unreadBadgesStore.dotMenuIds),
    });
  });
}
